import {Action} from '../../../commons/src/types'
import {ExtendedCognitoUserWithPermission, ProviderId} from '../types'

export type InitDoneAction = Action<'AUTH.INIT_DONE', void>
export type SignInAction = Action<
  'AUTH.SIGN_IN',
  {user: ExtendedCognitoUserWithPermission; providerId: ProviderId}
>
export type SignInDoneAction = Action<
  'AUTH.SIGN_IN_DONE',
  {user: ExtendedCognitoUserWithPermission; providerId?: ProviderId}
>
export type SignOutAction = Action<'AUTH.SIGN_OUT', {global: boolean}>

export type AuthAction = InitDoneAction | SignInAction | SignInDoneAction | SignOutAction

export const initDone = (): InitDoneAction => ({
  type: 'AUTH.INIT_DONE',
  payload: undefined,
})

export const signIn = (
  user: ExtendedCognitoUserWithPermission,
  providerId: ProviderId
): SignInAction => ({
  type: 'AUTH.SIGN_IN',
  payload: {
    user,
    providerId,
  },
})

export const signInDone = (
  user: ExtendedCognitoUserWithPermission,
  providerId?: ProviderId
): SignInDoneAction => ({
  type: 'AUTH.SIGN_IN_DONE',
  payload: {
    user,
    providerId,
  },
})

export const signOut = (global = false): SignOutAction => ({
  type: 'AUTH.SIGN_OUT',
  payload: {global},
})
